import React from "react";
import TakeOffDatasourceCard, { type TakeOffCardModel } from "../shared/TakeOffDatasourceCard";
import { useOst } from "./OstContext";

const useOstCardModel = (): TakeOffCardModel => {
  const { ostFileName, ostJobName, ostAggregatedQtos, ostTakeoffItemCount, ostLastUpdated, clearOstSession } = useOst();

  return {
    present: !!ostFileName,
    title: ostJobName ?? ostFileName ?? "",
    // The filename is the secondary line only when a job name took the primary one.
    secondary: ostJobName ? (ostFileName ?? undefined) : undefined,
    aggregatedQtos: ostAggregatedQtos,
    takeoffItemCount: ostTakeoffItemCount,
    lastUpdated: ostLastUpdated,
    emptyTooltip: "This file has no conditions to review",
    // An uploaded file has nowhere to open and nothing to refresh in place.
    onDisconnect: clearOstSession,
  };
};

const OstDatasourceCard = ({ onCardClick }: { onCardClick: () => void }) => {
  const model = useOstCardModel();
  return <TakeOffDatasourceCard sourceId="ost" model={model} onCardClick={onCardClick} />;
};

export default OstDatasourceCard;
